import React, { useEffect, useState } from "react";
import { faImages } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import Resizer from "react-image-file-resizer";
import {
  AddProductsApi,
  getCategoryDiscountApi,
} from "../../Api/BarestSupplierServices";
import MenuTitle from "../../Components/MenuTitlle/MenuTitle";
import { errorToast, succToast } from "../../Utils/Toast/Toast";
import Style from "./AddProductRestaurant.module.css";
import { useForm } from "react-hook-form";
const AddProductResturant = () => {
  const [files, setFiles] = useState([]);
  const [category, setCategory] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [,setPurchased] = useState(false);
  const [isBigImg, setIsBigImg] = useState(false);
  const [imgName, setImgName] = useState();
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [count, setCount] = useState("1");
  const [packed, setPacked] = useState(false);
  const { register, handleSubmit } = useForm();

  useEffect(() => {
    getCategory();
  }, []);

  const getCategory = async () => {
    const result = await getCategoryDiscountApi();
    setCategory(result.category);
  };
  ///////////////نمایش بزرگتر عکس
  const showBigPic = (img) => {
    setIsBigImg(true);
    setImgName(img);
  };
  ////////////حذف عکس
  const removeImage = (name) => {
    const newList = files.filter((item) => item !== name);
    setFiles(newList);
  };
  const UploadImage = async (images) => {
    return await resizeFile(images);
  };
  const resizeFile = (file) => {
    for (let i = 0; i < file.length; i++) {
      Resizer.imageFileResizer(
        file[i],
        1024,
        1024,
        "WEBP",
        100,
        0,
        (uri) => {
          setFiles((prevfiles) => [...prevfiles, uri]);
        },
        "base64"
      );
    }
  };
  const onSubmit = (data) => {
    setLoadingBtn(true);
    const info = {
      name: data.title,
      category_free:
        selectedCategory === "" ? category[0].id : selectedCategory,
      file: files,
      other_detail: data.describe,
      price: data.price,
      off_price: data.off ? data.off : 0,
      packed:packed?0:-1,
      count:count,
    };
    AddProductsApi(info, (res) => {
      if (res.status === 0) {
        setLoadingBtn(false);
        errorToast("ارور");
        setPurchased(false);
      } else {
        setLoadingBtn(false);
        succToast("موفق");
        setPurchased(false);
      }
    });
  };

  return (
    <div className={Style.PageHolder}>
      <MenuTitle title="افزودن محصول" />
      <div className={Style.imageHolder}>
        <img src="/Assets/Images/Product/AddProduct.svg" alt="support" />
      </div>
      {isBigImg ? (
        <div className={Style.bigImg} onClick={() => setIsBigImg(false)}>
          <img src={`${imgName}`} alt="" />
        </div>
      ) : null}

      <form onSubmit={handleSubmit(onSubmit)} className={Style.FormAddProduct}>
        <div className={Style.imagePart}>
          {files.map((item, index) => {
            return (
              <div key={index} className={Style.eachImage}>
                <div
                  className={Style.picHolder}
                  onClick={() => showBigPic(item)}
                >
                  <img src={`${item}`} alt="" />
                </div>
                <div
                  className={Style.iconHolder}
                  onClick={() => removeImage(item)}
                >
                  <FontAwesomeIcon icon={faTrashAlt} />
                </div>
              </div>
            );
          })}
        </div>
        <div className={Style.inptFileHolder}>
          <label htmlFor="imgSelect">
            <FontAwesomeIcon icon={faImages} />
          </label>
          <p>بارگذاری تصویر</p>
          <input
            type="file"
            id={"imgSelect"}
            onChange={(e) => UploadImage(e.target.files)}
            multiple
          />
        </div>
        <input
          {...register("title")}
          className={Style.fileInputPart2}
          placeholder={"عنوان محصول"}
        />

        <select
          name="category"
          className={Style.selectMenuPart}
          onChange={(e) => setSelectedCategory(e.target.value)}
        >
          {category.map((item) => (
            <option key={item.id} value={item.id}>
              {item.category}
            </option>
          ))}
        </select>
        <label className={Style.packedPart}>
          {" "}
          جزو محصولات بسته بندی شده است
          <input
            onChange={(e) => setPacked(e.target.checked)}
            className={Style.checkedPacked}
            type="checkbox"
          />
        </label>
        <select
          name=""
          id=""
          onChange={(e) => setCount(e.target.value)}
          value={count}
          className={Style.fileInputPart2}
        >
          <option value="1">موجود</option>
          <option value="0">ناموجود</option>
        </select>
        <textarea
          {...register("describe")}
          placeholder={"توضیحات تکمیلی"}
          className={Style.fileInputArea}
        />

        <input
          {...register("price")}
          placeholder={"قیمت محصول به تومان"}
          className={Style.fileInputPart2}
        />
        <input
          {...register("off")}
          placeholder={"قیمت با تخفیف به تومان"}
          className={Style.fileInputPart2}
        />
        <button className={Style.addBtn} disabled={loadingBtn}>
          {loadingBtn ? (
            <span style={{ fontSize: ".6rem", direction: "ltr" }}>
              ...لطفا صبر کنید
            </span>
          ) : (
            " افزودن"
          )}
        </button>
      </form>
    </div>
  );
};

export default AddProductResturant;
